<template>
    <div>
        <h4>恭喜你！</h4>
        <h2>付款成功，立即预约！</h2>
        <div class="btns">
            <div @click="gohome" class="no">暂不预约</div>
            <div @click="yuyue" class="yes">立即预约</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: 1
            }
        },
        methods: {
            yuyue() {
                let orderID = this.$route.query.orderID;
                if (orderID != undefined && orderID != '') {
                    this.$router.push('/user/confirmYuYue/' + orderID);
                } else {
                    this.$router.push('/user/orderyuyue')
                }
                return false;
            },
            gohome() {
                this.$router.push('/');
                return false;
            }
        },
    }
</script>

<style scoped lang='less'>
    h4 {
        color: #43852E;
        font-size: 1rem;
        padding-top: 30%;
        margin: 0;
    }
    h2,
    h4 {
        text-align: center;
    }
    h2 {
        font-size: 1.5rem;
        font-weight: normal;
    }
    .btns {
        padding-top: 4em;
        text-align: center;
        >div {
            display: inline-block;
            font-size: 1rem;
            line-height: 2.5em;
            height: 2.5em;
            border: 1px solid #43852E;
            width: 8em;
            text-align: center;
            background: #43852E;
            color: #fff;
            border-radius: 10px;
        }
        .no {
            background: #fff;
            color: #43852E;
            margin-right: 1em;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/paySuccess.vue